import { useState } from 'react';
import { Panel, PanelHeader, Group, Button, Title, Text, Snackbar } from '@vkontakte/vkui';
import { useNavigate } from 'react-router-dom';
import { openUrl } from '../utils/vkBridge';
import { REGISTER_URL } from '../constants/registerUrl';
import { FlowPreviewBanner } from '../components/FlowPreviewBanner';

export function AuthGatePage({
  previewMode,
  onExitPreview,
  onLoginClick,
}: {
  previewMode?: boolean;
  onExitPreview?: () => void;
  onLoginClick?: () => void;
} = {}) {
  const navigate = useNavigate();
  const [snack, setSnack] = useState<string | null>(null);

  const openRegister = async () => {
    const ok = await openUrl(REGISTER_URL);
    if (!ok) {
      setSnack(
        'Не удалось открыть сайт внутри VK. Скопируйте ссылку и откройте в браузере.',
      );
      await navigator.clipboard.writeText(REGISTER_URL).catch(() => {});
    }
  };

  const goLogin = () => {
    if (onLoginClick) onLoginClick();
    else navigate('/login');
  };

  return (
    <Panel id="auth-gate">
      <PanelHeader
        before={
          onExitPreview ? (
            <Button mode="tertiary" onClick={onExitPreview}>
              Выйти
            </Button>
          ) : undefined
        }
      >
        Пилоты Будущего
      </PanelHeader>
      {previewMode && (
        <Group style={{ margin: '0 16px' }}>
          <FlowPreviewBanner />
        </Group>
      )}
      <Group className="pb-glow-card" style={{ margin: 16 }}>
        <div style={{ padding: 16, textAlign: 'center' }}>
          <Title level="2" className="pb-hero-title">
            Докажи, что небо — это твоё
          </Title>
          <Text className="pb-body-text" style={{ marginTop: 12, color: 'var(--pb-text-secondary)' }}>
            Управляй дроном, соревнуйся с лучшими и выйди в финал чемпионата.
          </Text>
          <Button
            size="l"
            stretched
            className="pb-gradient-btn"
            style={{ marginTop: 24 }}
            onClick={() => void openRegister()}
          >
            Зарегистрироваться
          </Button>
          <Button
            size="l"
            stretched
            mode="secondary"
            style={{ marginTop: 12 }}
            onClick={goLogin}
          >
            Войти
          </Button>
        </div>
      </Group>
      {snack && <Snackbar onClose={() => setSnack(null)}>{snack}</Snackbar>}
    </Panel>
  );
}
